import { render, staticRenderFns } from "./play1.vue?vue&type=template&id=d50059b4&scoped=true&"
import script from "./play1.vue?vue&type=script&lang=js&"
export * from "./play1.vue?vue&type=script&lang=js&"
import style0 from "./play1.vue?vue&type=style&index=0&id=d50059b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d50059b4",
  null
  
)

export default component.exports